module.exports = __webpack_public_path__ + "img/1572776292.283da74c.jpg";